module.exports = __webpack_public_path__ + "static/media/hw_fu_28.5cc3b852.flv";